/**
 * Re-apply GAPI hosts after the device network or VPN path changes.
 * Dynamic import keeps boot from loading Firebase at module eval.
 */

export const NETWORK_PATH_CHANGE_EVENT = 'alea-network-path-change';

const DEBOUNCE_MS = 400;
let debounceTimer = 0;

export async function refreshGapiTransportOnReconnect(): Promise<void> {
  const { clearGapiTransportCache } = await import('./gapiConnectivity');
  clearGapiTransportCache();
  try {
    // Rebind from a fresh probe — do **not** flip proxy↔direct (that's login-only).
    const { refreshGapiTransportFromProbe } = await import('./firebase');
    await refreshGapiTransportFromProbe();
  } catch {
    /* Firebase may not be initialized yet */
  }
}

/** Debounced re-probe + Auth host rebind. Safe to call from online / VPN events. */
export function scheduleGapiTransportRefresh(): void {
  if (typeof window === 'undefined') return;
  window.clearTimeout(debounceTimer);
  debounceTimer = window.setTimeout(() => {
    window.dispatchEvent(new Event(NETWORK_PATH_CHANGE_EVENT));
    void refreshGapiTransportOnReconnect();
  }, DEBOUNCE_MS);
}
